"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckPayCodePolicyLink = exports.PAY_CODE_POLICY_MODAL_LINK_TEST_ID = void 0;
const Link_1 = require("@amzn/atoz-web/Link");
const Icons_1 = require("@amzn/atoz-web/Icons");
const Modal_1 = require("@amzn/atoz-web/Modal");
const react_1 = __importDefault(require("react"));
const PayCodePolicyModalContent_web_1 = require("./PayCodePolicyModalContent.web");
exports.PAY_CODE_POLICY_MODAL_LINK_TEST_ID = 'pay-code-policy-modal-link';
const CheckPayCodePolicyLink = ({ payCodePolicyInfo, payCodesInfo }) => {
    return (react_1.default.createElement(Modal_1.WithModal, { renderModal: (0, PayCodePolicyModalContent_web_1.renderPayCodePolicyModalContent)(payCodePolicyInfo, payCodesInfo) }, ({ open }) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Link_1.Link, { dataTestId: exports.PAY_CODE_POLICY_MODAL_LINK_TEST_ID, onClick: open, icon: react_1.default.createElement(Icons_1.IconQuestionCircle, { size: Icons_1.IconSize.ExtraSmall, title: "View Pay Classifications Description" }) })))));
};
exports.CheckPayCodePolicyLink = CheckPayCodePolicyLink;
